import React from 'react';
import { UtensilsCrossed } from 'lucide-react';

const MenuRow = ({ name, ingredients }) => (
  <div className="flex justify-between items-start gap-4 py-3 border-b border-gray-200 last:border-b-0">
    <div className="flex-1 min-w-0">
      <p className="font-semibold text-gray-800">{name}</p>
      {ingredients && <p className="text-sm text-gray-500 mt-1">{ingredients}</p>}
    </div>
  </div>
);

const MenuSection = ({ title, children }) => (
  <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
    <h3 className="text-xl font-bold text-blue-700 uppercase tracking-wide pb-3 border-b-2 border-gray-300 mb-4">
      {title}
    </h3>
    <div className="space-y-1">{children}</div>
  </div>
);

const Jidlo = () => {
  return (
    <section className="py-16 px-4 bg-gray-50 min-h-screen" data-testid="jidlo-section">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <UtensilsCrossed className="w-16 h-16 mx-auto text-blue-600 mb-4" />
          <h2 className="text-4xl font-bold text-gray-800">Jídlo</h2>
        </div>

        <div className="space-y-6">
          {/* SMAŽENÁ JÍDLA */}
          <MenuSection title="Smažená jídla">
            <MenuRow name="SMAŽENÝ SÝR + HRANOLKY" ingredients="(Kečup, tatarka, hořčice)" />
            <MenuRow name="STRIPSY + HRANOLKY" ingredients="(Kečup, tatarka, hořčice)" />
            <MenuRow name="HRANOLKY" ingredients="(Kečup, tatarka, hořčice)" />
            <MenuRow name="LANGOŠ" ingredients="(Kečup, tatarka, sýr, česnek)" />
            <MenuRow name="BRAMBORÁČKY" ingredients="(3 ks)" />
          </MenuSection>

          {/* MINUTKY */}
          <MenuSection title="Minutky">
            <MenuRow name="PÁREK V ROHLÍKU" ingredients="(Kečup, hořčice)" />
            <MenuRow name="2ks PÁREK + CHLEBA" ingredients="(Kečup, tatarka, hořčice)" />
            <MenuRow name="KLOBÁSA + CHLEBA" ingredients="(Kečup, tatarka, hořčice)" />
            <MenuRow name="4ks UTOPENEC + CHLEBA" />
          </MenuSection>

          {/* PIZZA */}
          <MenuSection title="Pizza ø 31 cm">
            <MenuRow name="AMERICANA" ingredients="(Tomato, Sýr, Šunka, Kukuřice)" />
            <MenuRow name="HAWAI" ingredients="(Tomato, Sýr, Šunka, Ananas)" />
            <MenuRow name="MARCO" ingredients="(Tomato, Slanina, Salám, Uzený sýr, Sýr)" />
            <MenuRow name="PICANTE" ingredients="(Tomato, Sýr, Slanina, Klobása, Cibule, Drcené chilli papričky, beraní rohy)" />
            <MenuRow name="QUATTRO FORMAGGI" ingredients="(Tomato, Hermelín, Eidam, Niva, Parmazán)" />
            <MenuRow name="VEGAN PRIMAVERA" ingredients="(Sugo, Rajčata, Uzené tofu, Veganský sýr, Špenát, Kukuřice)" />
            <MenuRow name="CAORLE" ingredients="(Tomato, sýr, slanina, salám, šunka)" />
            <MenuRow name="MAKEDONIA" ingredients="(Tomato, mozzarella, paprika, žampiony, kuřecí prsa, beraní rohy)" />
          </MenuSection>
        </div>
      </div>
    </section>
  );
};

export default Jidlo;
